import React from 'react';
import { FormControl, FormGroup, FormLabel } from '@mui/material';

import { InteractiveEditSnappingSettings } from '../../../../../library/layout-snapping/interactive-snapping/settings';
import { layoutSlice } from '../../../../../store/slices/layoutSlice';
import { useAppDispatch } from '../../../../hooks';
import { SnappingSettingsCheckbox } from './SnappingSettingsCheckbox';

export function InteractiveEditSnappingSettingsControls(props: { settings: InteractiveEditSnappingSettings }) {
  const dispatch = useAppDispatch();
  const { settings } = props;

  return (
    <FormControl>
      <FormLabel>Interactive Edit Snaps</FormLabel>
      <FormGroup>
        <SnappingSettingsCheckbox
          label="Grid"
          tooltip="Snap dragged or resized beams and walls to 1 ft layout grid lines."
          checked={settings.footGrid}
          onChange={() => dispatch(layoutSlice.actions.interactiveEditFootGridSnappingToggled())}
        />

        <SnappingSettingsCheckbox
          label="Endpoint Axes"
          tooltip="Snap edited beam and wall vertices to the x or y coordinate of active target endpoints."
          checked={settings.entityAxisSnaps.endpoints}
          onChange={() => dispatch(layoutSlice.actions.interactiveEditEndpointAxisSnappingToggled())}
        />

        <SnappingSettingsCheckbox
          label="Midpoint Axes"
          tooltip="Snap edited beam and wall vertices to the x or y coordinate of active target midpoints."
          checked={settings.entityAxisSnaps.midpoints}
          onChange={() => dispatch(layoutSlice.actions.interactiveEditMidpointAxisSnappingToggled())}
        />

        <SnappingSettingsCheckbox
          label="Aligned Lines"
          tooltip="Snap edited beam and wall vertices to vertical or horizontal active target lines."
          checked={settings.entityAxisSnaps.axisAlignedLines}
          onChange={() => dispatch(layoutSlice.actions.interactiveEditAxisAlignedLineSnappingToggled())}
        />
      </FormGroup>
    </FormControl>
  );
}
